/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.search-bar[_ngcontent-%COMP%]{\n    width: 100% !important;\n}\n\n@media only screen and (max-width: 999px){\n    #filters[_ngcontent-%COMP%] {\n        padding: 0;\n        margin: 0;\n        box-shadow: none;\n    }\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1maWx0ZXIvYm9va2luZy1maWx0ZXIuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvYm9va2luZy1tYW5hZ2VtZW50L2Jvb2tpbmctZmlsdGVyL2Jvb2tpbmctZmlsdGVyLmNvbXBvbmVudC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking-filter/booking-filter.component.css.shim.ngstyle.ts